import { createContext, useContext, useState } from "react";

const OpenContext = createContext();

export function OpenProvider({ children }) {
    const [openMap, setOpenMap] = useState({});

    const setOpenById = (id, value) => {
        setOpenMap(prev => ({ ...prev, [id]: value }));
    };

    return (
        <OpenContext.Provider value={{ openMap, setOpenById }}>
            {children}
        </OpenContext.Provider>
    );
}

export function useOpenContext() {
    const context = useContext(OpenContext);
    if (!context) {
        throw new Error("useOpenContext must be used within an OpenProvider");
    }
    return context;
}